export default {
    GetterCatalogue: (state) => (keyword) => {
        if (state.catalogue.filter(c => c.descId === keyword)) {
            if (state.catalogue.filter(c => c.descId === keyword).length > 0) {
                return state.catalogue.filter(c => c.descId === keyword)[0].data
            }
        }
        return new Array()
    },
    GetterRenseignement(state) {
        if(state.renseignements && state.renseignements.length > 0)
        return state.renseignements[0].listeRenseignementProDTO
        else
        return []
    },
    GetInfosFormulaire(state) {
        if (state.renseignements && state.renseignements.length > 0)
            return state.renseignements[0].formulaireDTO
        else
            return []
    },
    GetterRenseignementExistant(state)
    {
        return state.renseignements && state.renseignements.length > 0
    }
}